<template>
  <div class="container" :dir="textDirectionality" :lang="language">
    <!-- <div class="container" dir="rtl"> -->
    <div class="row mb-3 mb-lg-5">
      <div class="col-md-2 offset-md-10 col-6 offset-6">
        <Progress v-if="showProgress" type="full" />
      </div>
    </div>
    <transition name="fade" mode="out-in" v-on:leave="scrollTop">
      <!-- <div v-if="loaded"> -->
      <component
        :is="componentBody"
        ref="component"
        v-on:displayChanged="displayChanged"
        v-if="loaded"
      ></component>
      <!-- </div> -->
    </transition>
    <!-- <div v-if="error">
      <p>Failed to load next page. (Reason: {{ error }}.)</p>
      <button class="btn-lg btn-danger" @click="retry()">Retry</button>
    </div> -->
    <!-- NOTE: this is probably better be added to the group template. -->
    <div class="container my-5" v-if="showLastItemWarning">
      <p v-if="isTimed">
        {{ $t("messages.lastItemWarningTimed") }}
      </p>
      <p v-else>
        {{ $t("messages.lastItemWarningNonTimed") }}
      </p>
    </div>
    <!-- TODO: these will have to go into the child component as not all displayed items will have these. Also, we don't
    want these on the error screen (which is displayed in the child, too. -->
    <div class="row my-5 justify-content-between align-items-end">
      <div class="col-6 d-flex justify-content-start">
        <button
          id="prevButton"
          tabindex="1000"
          type="button"
          class="col-md-3 col-xs-12 btn btn-info"
          @click="previous()"
          v-if="showPrev"
        >
          {{ $t("buttons.previous") }}
        </button>
      </div>
      <div class="col-6 d-flex justify-content-end">
        <!-- <button type="button" class="btn-sm" @click="skip()">Skip</button> -->
        <button
          id="nextButton"
          tabindex="1010"
          type="button"
          class="col-md-3 col-xs-12 btn btn-info float-end"
          @click="next('button')"
          v-if="showNext"
          :disabled="disableNext"
        >
          {{ nextLabel | placeholder($t("buttons.next")) }}
        </button>
        <button
          id="submitButton"
          tabindex="1020"
          type="button"
          class="col-md-3 col-xs-12 btn btn-primary float-end"
          @click="finish()"
          v-if="showFinish"
          :disabled="disableNext"
        >
          {{ $t("buttons.submit") }}
        </button>
      </div>
    </div>
    <div
      class="modal show"
      id="errorModal"
      data-show="true"
      data-backdrop="static"
      style="display: block; padding-right: 5px"
      v-if="error"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              An error occured
            </h5>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("messages.errors.loadingFailed") }}
              <span v-if="!error.response">
                {{ $t("messages.errors.noConnection") }}
              </span>
              <!-- <span v-else>This is probably an error on our side and it has been logged.</span> -->
            </p>
          </div>
          <div class="modal-footer justify-content-around">
            <button tabindex="-1" class="btn-lg btn-danger" @click="retry()">
              {{ $t("buttons.retry") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/css/app.css'
import AsyncLock from 'async-lock'
import Http from '@/utils/http'
import store from '@/store'
import registry from './registry'
import Progress from './Progress'
// import { getTextDirectionality } from '../utils/i18n'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Assessment',
  components: { Progress },
  props: ['id'],

  data () {
    return {
      // componentBody: {
      //     template: '<div><span>Loading....</span></div>'
      // },
      dummy: '',
      loaded: false,
      error: null,
      retryOperation: null,
      elements: [
        {
          type: 'page',
          locale: {
            language: 'en',
            direction: 'ltr'
          },
          content: {
            content: '<div><span>Loading...</span></div>'
          }
        }
      ],
      activeElementIdx: 0,
      lastDisplayChange: 0,
      store
    }
  },
  methods: {
    // NOTE: this is never used, we don't have a skip button
    // skip() {
    //     console.log('Skip question(s)')
    //     // TODO: it's not a skip...
    //     Http.post(`assessments/${this.id}/response/`, this.component.getResponses()).then(response => {
    //         this.fetchNext()
    //     }).catch(error => {
    //         // Show error message (submission failed)
    //         console.log('Response submission failed. Reason: ', error)
    //     })
    // },
    submit () {
      if (this.component.needsSubmit) {
        console.debug('Submit responses')
        return Http.post(
          `assessments/${this.id}/responses/`,
          this.component.getResponses()
        ).catch((error) => {
          // TODO: Show error message / info bar (submission failed)?
          console.debug('Response submission failed. Reason: ', error)
          throw error
        })
      } else {
        return Promise.resolve()
      }
    },
    tick () {
      // console.log('Assessment.tick', this.$refs.component && this.$refs.component.tick);
      if (this.component && this.component.tick) {
        this.component.tick()
      }
    },
    displayChanged () {
      // TODO: maybe we could use the ":key" based technique (which would be pretty similar, but more standard) -> https://michaelnthiessen.com/force-re-render/
      // Force update of computed properties that depend on the child component. (Which is discouraged in the Vue docs, but we need it.)
      this.lastDisplayChange = new Date().getTime()
    },
    setRetry (method, args) {
      if (!this.retryOperation) {
        this.retryOperation = {
          method,
          args
        }
      }
    },
    loadingCompleted () {
      console.debug('Loading completed')
      this.error = null
      this.loaded = true
      this.retryOperation = null
      console.debug(
        `loadingCompleted: issue forceUpdate [elementUid = ${
          this.component.elementUid
        }, lock.isBusy = ${this.navigationLock.isBusy()}]`
      )
      // this.component.forceUpdate()
      // console.debug(`loadingCompleted: await DOM update [elementUid = ${this.component.elementUid}]`)
      // this.$nextTick()
      // console.debug(`loadingCompleted: DOM update done [elementUid = ${this.component.elementUid}]`)
    },
    fetchNext (nextQuestionRun) {
      // TODO: this should be a decorator
      this.setRetry(this.fetchNext, arguments)
      console.debug('fetchNext', arguments)

      // console.log(this, this.id, this.$props)
      // this.loaded = false
      const extra = nextQuestionRun ? `?id=${nextQuestionRun}` : ''

      return Http.get(`assessments/${this.id}/next/${extra}`).then(
        (response) => {
          // TODO: Maybe somehow use different components here and just provide the template. Either 'real' ones (defined in component files)
          //   or option objects where options can either be defined in the front end code (simpler) or fully come from the server. In which case
          //   they need to be compiled/loaded dynamically.

          this.elements = response.data
          this.activeElementIdx = 0
          // const data = response.data[0]
          // const data = this.elements[this.activeElementIdx]
          //
          // this.componentBody = COMPONENTS[data.type](data)
          this.loadingCompleted()
          // }).catch(error => {
          //     this.loaded = false
          //     this.error = error
        }
      )
    },
    previous () {
      this.setRetry(this.previous, arguments)
      const currentElement = this.component.elementUid
      console.debug('PREVIOUS: acquiring lock')
      this.navigationLock.acquire('key', () => {
        console.debug('PREVIOUS: acquired lock')
        if (currentElement === this.component.elementUid) {
          if (this.havePrevLocally) {
            this.submit()
              .then((response) => {
                this.activeElementIdx--
                this.loadingCompleted()
              })
              .catch((error) => {
                // this.loaded = false
                this.error = error
              })
          } else {
            // TODO: response submission (in some cases!) can be async and we could fetch the next question before it finishes
            // let promise =
            this.submit()
              .then((response) => {
                this.fetchNext(this.component.previous).then(() => {
                  console.debug('previous: fetchNext succeeded')
                  this.loadingCompleted()
                })
              })
              .catch((error) => {
                // this.loaded = false
                this.error = error
              })
          }
        } else {
          console.debug('previous: User has navigated away')
        }
      })
    },
    async next (src) {
      console.debug(`Execute NEXT [src = ${src}]`)
      // TODO: retry may collide with the navigation check
      this.setRetry(this.next, arguments)
      console.log(this.component.allowNext)

      // TODO: it's too late to get this here (if we're reacting to user input)
      const currentElement = this.component.elementUid
      console.debug(
        `NEXT: currentElement = ${currentElement}, acquiring lock [src = ${src}, lock.isBusy = ${this.navigationLock.isBusy()}]`
      )
      this.navigationLock.acquire('key', () => {
        console.debug(
          `NEXT: acquired lock [src = ${src}, lock.isBusy = ${this.navigationLock.isBusy()}]`
        )
        if (currentElement === this.component.elementUid) {
          console.debug(
            `NEXT: current element matches, executing [src = ${src}, haveNextLocally = ${this.haveNextLocally}]`
          )
          // TODO: here we have probably been testing the wrong branch :-/ . (We may have to retry the async/await version)
          if (this.haveNextLocally) {
            return this.submit()
              .then((response) => {
                this.activeElementIdx++
                this.loadingCompleted()
                console.debug(`NEXT: exiting critical section [src = ${src}]`)
              })
              .catch((error) => {
                // this.loaded = false;
                this.error = error
              })
          } else {
            // TODO: rewrite nested promises to a straight chain
            return this.submit()
              .then((response) => {
                return this.fetchNext(this.component.next).then(async () => {
                  this.displayChanged()
                  this.loadingCompleted()
                  console.debug(
                    `NEXT: exiting critical section [src = ${src}]`
                  )
                })
              })
              .catch((error) => {
                // this.loaded = false
                this.error = error
              })
          }
        } else {
          console.debug('NEXT: user has already navigated away')
        }
      })
    },
    finish () {
      // TODO: it's too late to get this here (if we're reacting to user input)
      const currentTest = this.component.test.id

      this.navigationLock.acquire('key', () => {
        if (currentTest === this.component.test.id) {
          this.setRetry(this.finish, arguments)
          // TODO: signal finising test to server
          this.submit()
            .then((response) => {
              Http.post(`assessments/${this.id}/submissions/`, {
                id: this.component.test.id
              }).then((response) => {
                this.fetchNext().then(() => {
                  this.loadingCompleted()
                })
              })
            })
            .catch((error) => {
              // this.loaded = false
              this.error = error
            })
        } else {
          console.debug('finish: User has navigated away')
        }
      })
    },
    autoSubmit (id) {
      // NOTE: there is a race condition we have to check for: the user may have submitted the current item
      //  in the meanwhile.
      // if ()
      console.debug(
        'Executing autoSubmit, acquiring lock. id = ',
        id.elementUid,
        id.testId
      )
      this.navigationLock.acquire('key', () => {
        console.debug(
          `autoSubmit: acquired lock. Current test.id =  ${
            this.component.test ? this.component.test.id : 'test is undefined'
          }, current elementUid = ${this.component.elementUid}`
        )
        // TODO: Is this logic below actually valid? Do we not want to finish if not on the last test? (Doing
        //   so would probably break memory test.)
        // NOTE: this seems to be faulty. What we want to do (also) depends on whether it's a test or a group timeout
        //  Though 'submissions' don't really have to be done for timed tests, so probably doesn't matter.
        // NOTE: this.component.test may not be there. Either due to the not 100% valid concurrency handling
        //  or because it's a page. So this is (again) a hack that's ugly but works
        if (this.component.test && id.testId === this.component.test.id) {
          if (this.component.next) {
            console.debug('autoSubmitting with "next"')
            return this.next('autoSubmit')
          } else {
            console.debug('autoSubmitting with "finish"')
            return this.finish()
          }
        } else {
          console.debug('Auto submit: user has already navigated away')
        }
        // done()

        // this.$nextTick(done)
      })
    },
    scrollTop () {
      this.$nextTick(function () {
        document.getElementsByTagName('html')[0].scrollTop = 0
        console.debug('->', document.getElementsByTagName('html')[0].scrollTop)
      })
    },
    retry () {
      console.log('Retrying...')
      // TODO: switch to using this: https://www.npmjs.com/package/retry-axios (then we don't need decorators or storing the current operation - probably)
      this.retryOperation.method.apply(this, this.retryOperation.args)
    },
    keyupHandler (event) {
      // TODO: use keycode constants
      switch (event.keyCode) {
        case 33:
          if (this.showPrev) {
            this.previous()
          }
          break
        case 34:
          if (this.showNext && !this.disableNext) {
            this.next()
          }
          break
      }
    },
    handleInputCompleted () {
      console.debug('! handleInputCompleted', this.haveNextLocally)
      // Only auto progress if the user would be allowed to navigate the manually AND if they are not reviewing
      // (i.e. they have not navigated back from the last item). The check is done in nextTick because updating
      // the response affects if Next is enabled.
      // TODO: how to know if we're not on the latest item?
      //   - store max id (question id? group id?) and check against that -> store max id of the current group
      //   and compare with that
      // TODO: flash Next button (with CSS animation) on auto advancing
      this.$nextTick(() => {
        if (this.showNext && !this.disableNext) {
          this.next('input completed')
        }
      })
    },
    handleEnter () {
      if (this.showNext && !this.disableNext) {
        this.$nextTick(() => {
          this.next('keyboard handler')
        })
      }
    }
  },
  computed: {
    haveNextLocally () {
      return this.activeElementIdx < this.elements.length - 1
    },
    havePrevLocally () {
      return this.activeElementIdx > 0
    },
    componentBody () {
      const data = this.elements[this.activeElementIdx]

      const component = registry[data.type](data)
      console.debug(
        'componentBody: activeElement = ',
        this.activeElementIdx,
        ' uid = ',
        component.elementUid
      )

      return component
    },
    showProgress () {
      return (
        this.elements[this.activeElementIdx].type === 'group' && !this.isTimed
      )
    },
    language () {
      // console.debug('! activeElement = ', this.elements[this.activeElementIdx])
      return this.elements[this.activeElementIdx].locale.language
      // return this.$i18n.locale
    },
    textDirectionality () {
      return this.elements[this.activeElementIdx].locale.directionality
      // return getTextDirectionality(this.language)
    },
    showNext () {
      console.debug(
        'showNext? ',
        this.lastDisplayChange,
        this.component.allowNext,
        this.component.next
      )
      return (
        this.component.allowNext &&
        (this.component.next || this.haveNextLocally)
      )
    },
    disableNext () {
      console.debug(
        `disableNext: ${this.component.id}, ${this.lastDisplayChange}, ${this.component.allowSkip}, ${this.component.allAnswered}`
      )
      return !(this.component.allowSkip || this.component.allAnswered)
    },
    nextLabel () {
      // return this.componentBody.data().nextLabel
      return this.component.nextLabel
    },
    showPrev () {
      return (
        this.component.allowPrev &&
        (this.component.previous || this.havePrevLocally)
      )
    },
    component () {
      const comp = this.$refs.component || {}

      // eslint-disable-next-line no-unused-vars
      const fu = this.lastDisplayChange
      console.debug(`this.component = ${comp.id}`)
      return this.$refs.component || {}
    },
    isTimed () {
      return this.component.isTimed
    },
    onLastItem () {
      return !this.component.next && !this.haveNextLocally
    },
    showLastItemWarning () {
      return this.onLastItem && this.showPrev && this.component.needsSubmit
    },
    showFinish () {
      console.debug('this.showFinish')
      return this.onLastItem && this.component.userCanFinish
    }
  },
  created () {
    this.navigationLock = new AsyncLock()
    console.debug('Created new navigationLock')
  },
  mounted () {
    console.log('Assessment.created')
    // console.log(process.env.NODE_ENV)
    // TODO: be somewhat more responsible here (maybe use a lib? or better? yet, create our own so that we always ever have one timer
    setInterval(this.tick, 250)
    window.addEventListener('keyup', this.keyupHandler)

    // TODO: this could be added to the template as `v-on:autoSubmit="autoSubmit"` -> is this the canonical/better way?
    this.$on('autoSubmit', function (id) {
      console.debug('Handle autoSubmit')
      // this.submit().then(response => {
      //   this.fetchNext()
      // })
      this.autoSubmit(id)
    })
    this.$on('inputCompleted', this.handleInputCompleted)
    this.fetchNext().catch((error) => {
      // this.loaded = false
      this.error = error
    })
  },
  unmounted () {
    window.removeEventListener('keyup', this.keyupHandler)
  }
}
</script>

<style>
/* font-family: 'Handlee', cursive; */
/* font-family: 'Shadows Into Light', cursive; */
.hand-written {
  font-family: "Gloria Hallelujah", cursive;
  font-size: 1.125em;
  letter-spacing: 0.06em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
